import http from "@/http-common";

/**
 * Service quản lý thống kê học phí (Tuition Statistic)
 * Base URL: /web/receipt/v1/statistic
 */
const BASE = "receipt/v1/statistic";
class TuitionStatisticService {

  /**
   * Tìm kiếm danh sách lớp/nhóm kèm tổng hợp tài chính
   * @param {Object} data - TuitionStatisticFilterRequest
   */
  filterStatistic(data) {
    return http.post(`${BASE}/filter`, data);
  }

  /**
   * Lấy dữ liệu biểu đồ tình trạng phiếu thu
   * @param {Object} params - year, kidStatus, category
   */
  getOrderChart(params) {
    return http.get(`${BASE}/chart/order`, { params });
  }

  /**
   * Lấy dữ liệu biểu đồ doanh thu
   * @param {Object} params - year, kidStatus, category, status
   */
  getRevenueChart(params) {
    return http.get(`${BASE}/chart/revenue`, { params });
  }

  /**
   * Xuất file thống kê chi tiết học sinh
   * @param {Object} data - ExportStudentStatisticRequest
   */
  exportDetailStudent(data) {
    return http.post(`${BASE}/export-detail-student`, data);
  }
}

export default new TuitionStatisticService();
